module.exports = __webpack_public_path__ + "img/1511028927.0ad9e08f.jpg";